'use strict'

define ['./forms.scss', './tour/tour.css', './tour/intro/intro.css', './tour/first_form/first_form.css'], () ->
  ($scope, $rootScope, $state, $stateParams, $http, $uibModal, ApplicationTemplate, RentappService, rowCollection, $cookies, $timeout, $window, Flash) ->
    $scope.plus_svg = require('./plus.svg')
    $scope.rowCollection = rowCollection.objects
    $scope.can_create = true
    

    RentappService.getMe()
      .then((resp) -> 
        $scope.can_create = resp.landlord.can_create
      )

    # For quick forms table pagination
    $scope.pagination_options = {}
    $scope.total_count = rowCollection.meta.total_count

    Shepherd = require('tether-shepherd')
    $window.Shepherd = Shepherd

    $scope.mobile_view = window.innerWidth < 768

    if $stateParams.quick_form
      Flash.create('success', "Your form for #{$stateParams.quick_form.property_address} has been successfully created for #{$stateParams.quick_form.account}. Here's the link: #{$rootScope.HOST}/#{$stateParams.quick_form.slug}", 0)
      
    if $cookies.get("just_signed_up") and $rootScope.WELCOME_MODAL_ENABLED
      $uibModal.open
        template: require("./welcomeModal.jade")
        controller: require("./welcomeModal.coffee")
        windowClass: 'welcome-modal'
      .result
      .then((result) ->
        $cookies.remove("just_signed_up")
      )

    $scope.start_first_form_tour = () ->
      $rootScope.$broadcast("first-form-tour-started")

      tour = new Shepherd.Tour
        defaults:
          classes: 'shepherd-theme-arrows onboard-tour'

      tour.addStep 'form-step1',
        text: require('./tour/first_form/step1.jade')
        attachTo: ".form-link-step #{if $scope.mobile_view then 'top' else 'bottom'}"
        showCancelLink: true
        buttons: [
          text: 'Next'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-center'
        ]

      tour.addStep 'form-step2',
        text: require('./tour/first_form/step2.jade')
        attachTo: ".form-services #{if $scope.mobile_view then 'top' else 'bottom'}"
        showCancelLink: true
        buttons: [
          text: 'Back'
          action: tour.back
          classes: 'buttons onboard-button onboard-button-back'
        ,
          text: 'Next'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-next'
        ]

      tour.addStep 'form-step3',
        text: require('./tour/first_form/step3.jade')
        attachTo: "send-application-link #{if $scope.mobile_view then 'top' else 'left'}"
        showCancelLink: true
        buttons: [
          text: 'Back'
          action: tour.back
          classes: 'buttons onboard-button onboard-button-back'
        ,
          text: 'Got it'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-next'
        ]

      tour.start()

    $scope.start_intro_tour = () ->
      $rootScope.$broadcast("intro-tour-started")

      tour = new Shepherd.Tour
        defaults:
          classes: 'shepherd-theme-arrows onboard-tour intro-steps'

      tour.addStep 'intro-step1',
        text: require('./tour/intro/step1.jade')
        attachTo: '.form-button bottom'
        showCancelLink: true
        buttons: [
          text: 'Next'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-center'
        ]
        when:
          show: () ->
            if $scope.mobile_view
              angular.element('.applicant-button').css({'margin-left': '180px'})

      tour.addStep 'intro-step2',
        text: require('./tour/intro/step2.jade')
        attachTo: '.applicant-button bottom'
        showCancelLink: true
        buttons: [
          text: 'Back'
          action: tour.back
          classes: 'buttons onboard-button onboard-button-back'
        ,
          text: 'Next'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-next'
        ]
        when:
          show: () ->
            if $scope.mobile_view
              angular.element('.form-button').css({position: 'relative'})
              angular.element('.applicant-button').css({'margin-left': '0px'})



      tour.addStep 'intro-step3',
        text: require('./tour/intro/step3.jade')
        attachTo: ".new-form-button #{if $scope.mobile_view then 'bottom' else 'left'}"
        showCancelLink: true
        buttons: [
          text: 'Back'
          action: tour.back
          classes: 'buttons onboard-button onboard-button-back'
        ,
          text: 'Got it'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-next'
        ]

      tour.start()

    if $cookies.get("just_created_first_form")
      if !$scope.mobile_view
        $timeout(()->
          $scope.start_first_form_tour()
        , 10)
      $cookies.remove("just_created_first_form")



// WEBPACK FOOTER //
// ./components/dashboard/forms/forms.coffee